module.exports = __webpack_public_path__ + "js/0.3b88cee5.worker.js"